module.exports = __webpack_public_path__ + "img/interaction-bar-search-toyota.cc985afa.png";